import { render, staticRenderFns } from "./popTips.vue?vue&type=template&id=4a7c3645&scoped=true"
import script from "./popTips.vue?vue&type=script&lang=js"
export * from "./popTips.vue?vue&type=script&lang=js"
import style0 from "./popTips.vue?vue&type=style&index=0&id=4a7c3645&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7c3645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7c3645')) {
      api.createRecord('4a7c3645', component.options)
    } else {
      api.reload('4a7c3645', component.options)
    }
    module.hot.accept("./popTips.vue?vue&type=template&id=4a7c3645&scoped=true", function () {
      api.rerender('4a7c3645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/common/popTips.vue"
export default component.exports